import script from "./OverviewPageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewPageCard.vue?vue&type=script&setup=true&lang=js"

import "./OverviewPageCard.vue?vue&type=style&index=0&id=1973362a&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1973362a"]])

export default __exports__